import { z } from "zod";

export const AuthLogItem = z.object({
  id: z.number(),
  userId: z.number(),
  event: z.string(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  location: z.string().nullable(),
  source: z.string(),
  createdAt: z.coerce.date(),
  user: z.object({
    id: z.number(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string()
  })
});

export const AuthLogsResponse = z.array(AuthLogItem);

export type TAuthLogItem = z.infer<typeof AuthLogItem>;
